export enum SlideType {
  HOME = 'home',
  BAR_GRAPH = 'bar_graph',
  PIE_CHART = 'pie_chart',
  ATTENDANCE = 'attendance',
  TIMER = 'timer',
  RESTRICTED = 'restricted',
}

export interface TimerMetaData {
  bgImg: string;
  title: string;
  countdownFrom: number;
  ranTill: number;
}

export interface Metadata {
  url: string;
  slideType: SlideType;
  timer?: TimerMetaData;
}

export enum DialogTypes {
  BAR_GRAPH = 'bar_graph',
  PIE_CHART = 'pie_chart',
  ATTENDANCE = 'attendance',
  TIMER = 'timer',
  COPY_ACTIVITY = 'copy_activity',
}

export interface AcadlyPreferences {
  hiddenDialogs: DialogTypes[];
  pinnedCourseIds: string[];
}
